import React from "react";
import LiveMatchTrackerSoccer from "../Pages/Score/Soccer.js/ScoreBoardSoccer";
import LiveMatchTrackerTennis from "../Pages/Score/Tennis/ScoreBoard";
import LiveMatchTrackerCricket from "../Pages/Score/Cricket/ScoerBoardDetail";

const DisplayScore = ({ detail }) => {
  let tabPosition = {
    cricket: "bottom",
    tennis: "top",
    soccer: "bottom",
  };
  if (detail?.isCustomUrl) {
    return (
      <iframe
        className="responsive-iframe w-100"
        style={{
          overflow: "hidden",
          height: detail?.screenScore === "full" ? "270px" : "141px",
          backgroundColor: "#000000",
          width: "100%",
        }}
        id="scoreId"
        src={detail?.scoreURL}
      />
    );
  } else {
    return detail?.gameType === "soccer" ? (
      <LiveMatchTrackerSoccer
        type="inner"
        tabPosition={tabPosition[detail?.gameType]}
        scoreId={detail?.scoreId}
      />
    ) : detail?.gameType === "tennis" ? (
      <LiveMatchTrackerTennis
        type="inner"
        tabPosition={tabPosition[detail?.gameType]}
        scoreId={detail?.scoreId}
      />
    ) : (
      <LiveMatchTrackerCricket
        type="inner"
        tabPosition={tabPosition[detail?.gameType]}
        scoreId={detail?.scoreId}
      />
    );
  }
};

export default DisplayScore;
